export const laptopLayoutMediaQuery = '(min-width: 992px) and (max-width: 1600px)';

/**
 * Checks whether the current viewport matches the provided media query.
 *
 * @param mediaQuery The media query to evaluate.
 * @returns True when the media query matches; otherwise, false.
 */
export function matchesMediaQuery(mediaQuery: string): boolean {
  return typeof window !== 'undefined'
    && window.matchMedia(mediaQuery).matches;
}